import {useMemo} from 'react';
import {useUser} from '@dofleini/security';

export const useVerifyLabDataAccess = () => {
  const {user} = useUser();

  const hasNotLabDataRestriction = useMemo(() => {
    return (!user?.labDataAccess || (user.labDataAccess?.length === 0));
  }, [user.labDataAccess]);

  const isLabDataFood = useMemo(() => {
    return user?.labDataAccess?.includes('labDataFood');
  }, [user.labDataAccess]);

  const isLabDataLegionella = useMemo(() => {
    return user?.labDataAccess?.includes('labDataLegionella');
  }, [user.labDataAccess]);

  const isLabDataPool = useMemo(() => {
    return user?.labDataAccess?.includes('labDataPool');
  }, [user.labDataAccess]);

  const isLabDataOthers = useMemo(() => {
    return user?.labDataAccess?.includes('labDataOthers');
  }, [user.labDataAccess]);

  return ({
    hasNotLabDataRestriction,
    isLabDataFood,
    isLabDataLegionella,
    isLabDataPool,
    isLabDataOthers
  });
};
